import React, { useContext } from 'react';
import { UserContext } from './UserContext';
import { logout } from './api';

const Logout = () => {
  const { setUser } = useContext(UserContext);

  const handleLogout = () => {
    logout();
    setUser(null);
  };

  return <button onClick={handleLogout}>Se déconnecter</button>;
};

export default Logout;